module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9q4U2"))).then(() => module.bundle.root('d181N'));